import { requireEnv } from '@/utils/env.js';

/** Where a tab keeps the build it last reloaded for. */
const RELOADED_FOR_BUILD_KEY = 'reloadedForBuild';

/**
 * Reload the page to pick up a newer build after part of it failed to load
 * (a chunk a deploy replaced), at most once per build in this tab. Only a
 * new build can mend a chunk that will not load, so a second failure on the
 * same build goes to the page's error instead of reloading again.
 *
 * The tab remembers the build it reloaded for, never cleared on a page
 * `load`. The guards this replaced were flags cleared on every `load`, and a
 * failure that comes after it (the receipt viewer's pdf.js worker, refused
 * on staging and production as the wrong type) reloaded the review page
 * every four seconds, each load renewing the session, until the sign-in
 * limit refused them (2026-10-13).
 *
 * @param {() => void} [reload] - How the page reloads; the browser's own unless a test counts them.
 * @returns {boolean} Whether a reload was started.
 */
export const reloadOncePerBuild = (reload = () => window.location.reload()) => {
  const build = requireEnv('VITE_VERSION');
  if (sessionStorage.getItem(RELOADED_FOR_BUILD_KEY) === build) return false;
  sessionStorage.setItem(RELOADED_FOR_BUILD_KEY, build);
  reload();
  return true;
};
